/**
 * @generated SignedSource<<1ff01fddbd2490ff9d470378e85bc61b>>
 * @relayHash 8173ad007760bc51417af52b73617c90
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9764f3dade922b53868cc5c99d648934d3a6f314589148100af8766923e70186

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceRecipientType = "GROUP" | "TEAM" | "USER" | "%future added value";
export type ConfluenceContentShareRequestInput = {
  comment?: string | null | undefined;
  content: ConfluenceShareContent;
  contentShareMetadata?: ConfluenceContentShareMetadata | null | undefined;
  recipients?: ReadonlyArray<ConfluenceContentShareRecipient | null | undefined> | null | undefined;
  sharerAaid?: string | null | undefined;
};
export type ConfluenceShareContent = {
  contentId: string;
  contentUrl?: string | null | undefined;
};
export type ConfluenceContentShareMetadata = {
  altOrigin?: string | null | undefined;
  shareAction?: string | null | undefined;
};
export type ConfluenceContentShareRecipient = {
  email?: string | null | undefined;
  id?: string | null | undefined;
  recipientType: ConfluenceRecipientType;
};
export type useShareToPrincipalsShareContentMutation$variables = {
  cloudId: string;
  input?: ConfluenceContentShareRequestInput | null | undefined;
};
export type useShareToPrincipalsShareContentMutation$data = {
  readonly confluence_shareContent: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
    readonly triggerId: string | null | undefined;
  } | null | undefined;
};
export type useShareToPrincipalsShareContentMutation = {
  response: useShareToPrincipalsShareContentMutation$data;
  variables: useShareToPrincipalsShareContentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "ContentShareRequestInput",
        "variableName": "input"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceShareContentPayload",
    "kind": "LinkedField",
    "name": "confluence_shareContent",
    "plural": false,
    "selections": [
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "kind": "ScalarField",
        "name": "triggerId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useShareToPrincipalsShareContentMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useShareToPrincipalsShareContentMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8173ad007760bc51417af52b73617c90",
    "id": "9764f3dade922b53868cc5c99d648934d3a6f314589148100af8766923e70186",
    "metadata": {},
    "name": "useShareToPrincipalsShareContentMutation",
    "operationKind": "mutation",
    "text": "mutation useShareToPrincipalsShareContentMutation($input:ConfluenceContentShareRequestInput,$cloudId:ID!){confluence_shareContent(ContentShareRequestInput:$input,cloudId:$cloudId){errors{message},success,triggerId}}"
  }
};
})();

(node as any).hash = "40821d61382eb61bc5c946b0b9c6682a";

export default node;
